'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeCompany = require('./KayleeCompany');
var KayleeConnectionState = require('./KayleeConnectionState');
var KayleeUser = require('./KayleeUser');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeCompanies');

var KayleeCompanies = {
    fromJson: fromJson,
    getCompanies: getCompanies,
};

function fromJson(data) {
    var reqProps = [ '$userId' ];
    return FirebaseIndirectArray.$fromJson(data, 'Companies', reqProps, reqProps,
        function(data) { return getCompanies(data.$userId); }
    );
}

function getCompanies(userId) {
    if (typeof userId === 'undefined' || userId === null) {
        if (KayleeBase.app.auth().currentUser === null) return null;
        userId = KayleeBase.app.auth().currentUser.uid;
    }

    var key = 'Companies: ' + userId;
    var companies = KayleeCache.get(key);

    if (companies === null) {
        companies = new Companies(userId);
        KayleeCache.put(key, companies);
    }

    return companies;
}

function Companies(userId) {
    var self = this;

    FirebaseIndirectArray.call(self, null, KayleeCompany.getCompany);
    self.$nodeType = 'companies';
    self.$user = KayleeUser.getUser(userId);
    KayleeUtil.bindPrototypeMethods(Companies.prototype, self, self.$items);
    this.$items.$self = this;

    if (KayleeConnectionState.isWorkingOnline()) {
        self.$user.$loaded()
        .then(function() {
            var srcRef =
                self.$getSrcRef(KayleeBase.isDbRoleEnabled && self.$user.$getRoleForDb() !== null);
            self.$setSrcRef(srcRef);

            if (KayleeBase.isDbRoleEnabled) {
                self.$user.$ref.child('roles/role').on('value', self.$dbRoleChangedCb,
                    self.$dbRoleCancelledCb, self);
            }
        });
    }

    return self.$items;
}

Companies.prototype = Object.create(FirebaseIndirectArray.prototype);
Companies.prototype.constructor = Companies;

Companies.prototype.toString = function() {
    return '[Companies for ' + this.$user + ']';
};

Companies.prototype.$getSrcRef = function(canWatchAllCompanies) {
    return canWatchAllCompanies ?
        KayleeBase.app.database().ref('companies') :
        this.$user.$ref.child('roles/companies');
};

Companies.prototype.$dbRoleChangedCb = function(snap) {
    var newDbRole = snap.val();
    var oldWatchAll = this.$user.$canWatchAllCompanies();
    var newWatchAll = this.$user.$canWatchAllCompanies(newDbRole);

    if (this.$user.$getRoleForDb() !== newDbRole) {
        log.debug('db role changed to ' + newDbRole + ' for ' + this.$user);
    }

    if (oldWatchAll !== newWatchAll) {
        this.$setSrcRef(this.$getSrcRef(newWatchAll));
    }
};

Companies.prototype.$dbRoleCancelledCb = function(err) {
    //log.debug('db role cancelled for ' + this.$user + ', error: ' + err);

    // FirebaseIndirectArray takes care of cleaning up itself when the
    // subscription for its srcRef is cancelled, then KayleeCache takes care of
    // removing the array from the cache via FirebaseIndirectArray's $onDestroy.
    // All we need to do is stop watching the db role.

    this.$user.$ref.child('roles/role')
    .off('value', this.$dbRoleChangedCb, this);
};

Companies.prototype.$getAlertCount = function() {
    var alertCount = 0;

    this.$items.forEach(function(company) {
        alertCount += company.$getAlertCount();
    });

    return alertCount;
};

Companies.prototype.$getControllerCount = function() {
    var controllerCount = 0;

    this.$items.forEach(function(company) {
        controllerCount += company.$getControllerCount();
    });

    return controllerCount;
};

Companies.prototype.$getInCallCount = function() {
    var inCallCount = 0;

    this.$items.forEach(function(company) {
        inCallCount += company.$getInCallCount();
    });

    return inCallCount;
};

Companies.prototype.$getRoomCount = function() {
    var roomCount = 0;

    this.$items.forEach(function(company) {
        roomCount += company.$getRoomCount();
    });

    return roomCount;
};

Companies.prototype.$toJson = function() {
    return  FirebaseIndirectArray.prototype.$toJson.call(this,
        [ ], { $userId: this.$user.$id });
};

module.exports = KayleeCompanies;
